<div class="topbar">
    <div class="logo">
        <img src="assets/logo.svg" />
    </div>
    <div class="fill"></div>
    <div class="search"></div>
</div>
